export enum EnumData {
	GOOGLE_MAP_API_KEY = 'AIzaSyCHReBe_RpzAgLTrUC5QIDyeKttQ817wRY',

	// MEDIUM TYPES
	MEDIUM_TYPE_WHATSAPP = 'WHATSAPP',

	// MEDIA TYPE
	MEDIA_TYPE_IMAGE = 'IMAGE',
	MEDIA_TYPE_VIDEO = 'VIDEO',
	MEDIA_TYPE_DOCUMENT = 'DOCUMENT',
	MEDIA_TYPE_LOCATION = 'LOCATION',

	// SCHEDULER TYPES
	SCHEDULER_TYPE_NOW = 'NOW',
	SCHEDULER_TYPE_SINGLE = 'SINGLE',
	SCHEDULER_TYPE_MULTIPLE = 'MULTIPLE',
}
